export default "__VITE_ASSET__Dkr9Wfnm__"